import React, { useState } from "react";
import "../../assets/scss/components/templates/toggleBtn.scss";

const ToggleButtonCustom = ({ isToggled, onToggle }) => {
  return (
    <label class="switch">
      <input type="checkbox" checked={isToggled} onChange={onToggle} />
      <span class="slider1 round"></span>
    </label>
  );
};

export default ToggleButtonCustom;
